import { z } from 'zod'

import { getHostRuntime } from '@/Atomic/Widgets/AiChatBot/core/engine/host-runtime'
import { resolvePageContext } from '@/Atomic/Widgets/AiChatBot/core/engine/pipeline/pipeline'
import { defineTool } from '@/Atomic/Widgets/AiChatBot/core/engine/runtime/tool-system'

export const getCurrentPageTool = defineTool({
  name: 'get_current_page',
  cacheable: false,
  description:
    'Returns the current page context: on a detail page returns the entity type and ID; on a list page returns the entity type and mode "list"; on the dashboard returns mode "dashboard". Call this whenever the user asks about "this record", "this company", "where am I", "which page", or similar.',
  inputSchema: () => z.object({}),

  async run() {
    const pageCtx = resolvePageContext()
    if (pageCtx.mode === 'detail') {
      return {
        currentPage: {
          mode: 'detail',
          dataClass: pageCtx.dataClass,
          id: pageCtx.id,
        },
      }
    }
    if (pageCtx.mode === 'dashboard') {
      return { currentPage: { mode: 'dashboard' } }
    }

    // Applied-filter resolution (saved-filter `?filter=<id>` wins over inline
    // `?query=`) is shared with the filter tools so both read it identically.
    const activeFilter =
      (await getHostRuntime().data.getAppliedFilterStructure()) ?? null

    return {
      currentPage: {
        mode: 'list',
        dataClass: pageCtx.dataClass,
        activeFilter,
        urlQuery: pageCtx.urlQuery ?? {},
      },
    }
  },
})
